import React from 'react';

export type ChatNotificationItem = { id: string; channelId: number; senderName: string; contentPreview: string; createdAt: string };

interface Props {
  notifications: ChatNotificationItem[];
  onOpenChat: (channelId: number) => void;
  onDismiss: (id: string) => void;
}

export const ChatNotificationToast: React.FC<Props> = () => null;
